var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._g(_vm._b({attrs:{"cols":"12"}},'v-col',_vm.$attrs,false),_vm.$listeners),[_c('p',{staticClass:"mb-3 text-start",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }